module.exports = __webpack_public_path__ + "media/performance/chart-2ce6aca9.svg";